// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".survey-statistics__question{display:block;margin-bottom:20px}.survey-statistics__question:last-child{margin-bottom:0}.survey-statistics__question__title{font-weight:bold;margin-bottom:15px}.survey-statistics__question__body{margin-left:10px}.survey-statistics__question__average-score{margin-top:15px}.survey-statistics__question__average-score__title{font-weight:bold}", ""]);
// Exports
module.exports = exports;
